import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../../assets/images/logo.svg";
import { ReactComponent as LinkIcon } from "../../../assets/icons/links.svg";
import { ReactComponent as ArrowLeft } from "../../../assets/icons/arrowleft.svg";
import { ReactComponent as Spinner } from "../../../assets/icons/spinner.svg";
import { useForgotMutation } from "../../../store/auth/usersApiSlice";

const Email = ({ onNext, PassNext, onEmail }) => {
  const [email, setEmail] = useState(onEmail);
  const [error, setError] = useState(null);

  const [forgot, { isLoading }] = useForgotMutation();
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let userEmail = urlParams.get("email");
    let userToken = urlParams.get("token");
    if (userEmail && userToken) {
      setEmail(userEmail);
      PassNext();
    }
  }, [PassNext]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await forgot({
        email,
      }).unwrap();

      if (res) {
        onNext(email);
      }
    } catch (error) {
      setError(error?.data?.email?.[0] || error?.data?.non_field_errors?.[0] || "Went Something wrong!");
    }
  };

  return (
    <>
      <div className="flex h-full flex-1 flex-col justify-between py-12 reset-section">
        <div className="mt-10 md:mx-auto md:w-full md:max-w-xl sm:max-w-sm sm:w-full sm:mx-auto">
          <div className="w-full md:mx-auto">
            <Link className="w-full" to="/">
              <div className="w-full flex justify-center">
                <Logo />
              </div>
            </Link>
            <h3 className="font-heading text-h3 text-primary font-bold mb-4 text-center pt-5">
              Reset Your Password
            </h3>
            <p className="text-secondarytwo text-para3 mt-2">
              Please enter the email address you'd like your <br /> password
              reset information sent to.
            </p>
          </div>
          <form className="space-y-6 mt-12" onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium leading-6 text-primary text-left"
              >
                Email
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  placeholder="email"
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  required
                  className="block w-full rounded-md py-3 px-3 text-gray-900 shadow-sm placeholder:text-gray-400 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            {error && <div className="text-left text-red-500">{error}</div>}
            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-primary px-3 py-3 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {isLoading ? <Spinner /> : "Reset your password"}
              </button>
            </div>
            <Link
              to="/login"
              className="inline-flex items-center justify-center mr-2 gap-2 font-bold"
            >
              {" "}
              <ArrowLeft /> Go Back to Log In{" "}
            </Link>
          </form>
        </div>

        <div>
          <p>{`Copyright @ ${new Date().getFullYear()} TREVEX, Inc`} </p>
          <Link
            to="/privacy-policy"
            className="inline-flex items-center justify-center mr-2 gap-2 font-bold"
          >
            Privacy Policy <LinkIcon />{" "}
          </Link>
        </div>
      </div>
    </>
  );
};

export default Email;
